import {
  UPDATE_REGISTRY_SUCCESS,
  UPDATE_REGISTRY,
  CLEAR_PROFILE, CLEAR_REGISTRY,
} from '../../constants/constants';

export const updateRegistry = (registry) => ({
  type: UPDATE_REGISTRY,
  payload: {
    registry: registry,
  }
});

export const updateRegistrySuccess = (updates) => ({
  type: UPDATE_REGISTRY_SUCCESS,
  payload: updates
});

export const clearRegistry = () => ({
  type: CLEAR_REGISTRY
});
